import { CircularProgress, styled } from '@ori-ui/mui';
import { memo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Root = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  textAlign: 'center'
});
export var Loading = /*#__PURE__*/memo(function () {
  return /*#__PURE__*/_jsx(Root, {
    children: /*#__PURE__*/_jsx(CircularProgress, {
      color: "primary"
    })
  });
});